<div class="search-field">
    <c11n-icon class="search-field__search-icon" [name]="'search'" [size]="'small'"></c11n-icon>
    <c11n-input class="search-field__input" [size]="'medium'">
        <input
            #searchInput
            c11nInput
            [zciKeyboardEventRegexValidate]="regex"
            type="text"
            [placeholder]="placeholder"
            [attr.aria-label]="placeholder"
            [formControl]="searchField"
            (keydown.enter)="onApproveSearchValue()"
            data-cy="search-input" />
    </c11n-input>
    <button
        *ngIf="searchField.value"
        type="button"
        class="search-field__remove-button"
        [attr.aria-label]="removeButtonAriaLabel"
        (click)="onRemoveSearchValue()">
        <c11n-icon class="" [name]="'remove'" [size]="'small'"></c11n-icon>
    </button>
</div>
